












































































































import QErrors from "@/common/qErrors.vue";
import isEmpty from "lodash/isEmpty";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "EventAddCertificatePopupComponent",
  components: {
    QErrors,
  },
})
export default class EventAddCertificatePopupComponent extends Vue {
  public isShow = false;

  public config = {
    is_display_code: true,
    is_display_price: true,
    date: {
      year: String(new Date().getFullYear()),
      month: String(new Date().getMonth() + 1),
      day: String(new Date().getDate()),
    },
    signature: "成田隆輝",
  };

  public errors = {};

  @Watch("isShow")
  public reset() {
    if (this.isShow === false) {
      this.config = {
        is_display_code: true,
        is_display_price: true,
        date: {
          year: String(new Date().getFullYear()),
          month: String(new Date().getMonth() + 1),
          day: String(new Date().getDate()),
        },
        signature: "成田隆輝",
      };
    }
  }

  @Watch("config.date.month")
  public validateMonth() {
    if (Number(this.config.date.month) > 12) {
      this.config.date.month = "12";
    }
  }

  @Watch("config.date.day")
  public validateDay() {
    if (Number(this.config.date.day) > 31) {
      this.config.date.day = "31";
    }
  }

  public async checkForm() {
    this.errors = {};

    if (this.config.date.year === "") {
      this.errors = {
        ...this.errors,
        ...{
          "config.date.year": ["必須入力"],
        },
      };
    }

    if (this.config.date.month === "") {
      this.errors = {
        ...this.errors,
        ...{
          "config.date.month": ["必須入力"],
        },
      };
    }

    if (this.config.date.day === "") {
      this.errors = {
        ...this.errors,
        ...{
          "config.date.day": ["必須入力"],
        },
      };
    }

    if (this.config.signature.length > 5) {
      this.errors = {
        ...this.errors,
        ...{
          "config.signature": ["全角5文字まで"],
        },
      };
    }
  }

  public submit() {
    this.checkForm().then(() => {
      if (isEmpty(this.errors)) {
        this.isShow = false;
        this.$emit("generateCert", this.config);
      }
    });
  }

  public confirmCancel() {
    this.$modal.showCancel({
      text: "XXXXXXを削除します。",
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.isShow = false;
        console.log("onConfirm");
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public clearError(name) {
    this.errors = { ...this.errors, ...{ [name]: [] } };
  }
}
